/**
 * Copyright (c) 2024-2026 Ronan LE MEILLAT
 * License: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import type React from "react";
import { Toast } from "@heroui/react";
import { CartProvider } from "@/hooks/use-cart";
import { CartDrawerProvider } from "@/contexts/cart-drawer-context";
import { StoreThemeProvider } from "@/providers/theme-provider";

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <StoreThemeProvider>
      <Toast.Provider />
      <CartProvider>
        <CartDrawerProvider>
          {children}
        </CartDrawerProvider>
      </CartProvider>
    </StoreThemeProvider>
  );
}
